import * as React from 'react';

import { StarRating } from '../StarRating';
import { AwardsContainer, CommentContainer, StarContainer } from './Awards.styles';

export const Awards = () => (
  <AwardsContainer data-id="awards">
    <StarContainer>
      <StarRating rating={4.5} />
    </StarContainer>
    <CommentContainer>
      <p>Rated 4.5</p>
      <p>10k+ ratings</p>
      <p>App Store &ndash; Aug &lsquo;21</p>
    </CommentContainer>
  </AwardsContainer>
);
